import {mapStates, mapActions, mapMutations, mapGetters} from './../baseModule'

const connection = 'specifications'
const collection = 'eventsSpecifications'

const model = {
  sourceDb: '',
  eventId: '',
  event: {
    city: '',
    reference: ''
  },
  gps: {
    lat: '',
    lng: ''
  },
  tags: {},
  tagsIds: [],
  refrigeratorIcon: '',
  educationalIcon: ''
}

export default {
  namespaced: true,
  state: {
    ...mapStates(),
    loading: true,
    all: [],
    one: Object.assign({}, model),
    count: 0,
    imagesMap: {
      basePath: '/static/img/icones_mapa/',
      personas: [
        'trg_person_0.png',
        'trg_person_25.png',
        'trg_person_50.png',
        'trg_person_90.png',
        'trg_person_150.png',
        'trg_person_210.png',
        'trg_person_270.png',
        'trg_person_330.png'
      ],
      trucks: [
        'truck_0.png',
        'truck_25.png',
        'truck_50.png',
        'truck_90.png',
        'truck_150.png',
        'truck_210.png',
        'truck_270.png',
        'truck_330.png'
      ],
      refrigerators: [
        'troca_geladeira_0.png',
        'troca_geladeira_60.png',
        'troca_geladeira_120.png',
        'troca_geladeira_180.png',
        'troca_geladeira_240.png',
        'troca_geladeira_300.png'
      ],
      educational: [
        'educacional_0.png',
        'educacional_60.png',
        'educacional_120.png',
        'educacional_180.png',
        'educacional_240.png',
        'educacional_390.png'
      ]
    }
  },
  mutations: {
    ...mapMutations(),
    SET_TAG (state, payload) {
      state.one.tags[payload.categorie] = payload.tag
      state.one.tagsIds = []
      for (let categorie in state.one.tags) {
        state.one.tagsIds.push(state.one.tags[categorie])
      }
    }
  },
  actions: {
    ...mapActions(collection, model, connection),
    setTags (context, {categorie, tag}) {
      context.commit('SET_TAG', {categorie, tag})
    }
  },
  getters: {
    ...mapGetters(),
    eventSpecifications: state => {
      return Object.assign({}, model, state.one)
    },
    eventsSpecifications: state => {
      return state.all.map(item => Object.assign({}, model, item))
    },
    withGpsEventsSpecifications: state => {
      return state.all.filter(item => {
        return item.hasOwnProperty('gps') &&
          item.gps.hasOwnProperty('lat') && item.gps.lat !== '' &&
          item.gps.hasOwnProperty('lng') && item.gps.lng !== ''
      }).map(item => Object.assign({}, model, item))
    },
    imagesMap: state => {
      return state.imagesMap
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/eventsSpecifications.js